import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const BatchLanguages = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 40 40" {...rest}>
      <g filter="url(#a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.032 24.694c-4.067 2.429-9.413 1.892-12.916-1.61-4.137-4.138-4.137-10.845 0-14.981 4.137-4.137 10.844-4.137 14.98 0 3.503 3.502 4.04 8.845 1.613 12.912l.16 3.043a.757.757 0 0 1-.795.796l-3.042-.16Z"
          fill="#89BAFF"
          fillOpacity={0.3}
        />
      </g>
      <g filter="url(#b)">
        <path
          d="M30.799 29.109c3.82-5.627 3.499-13.332-1.228-18.646C23.99 4.188 14.376 3.626 8.101 9.21c-6.276 5.582-6.838 15.195-1.255 21.47 4.726 5.314 12.342 6.532 18.375 3.392l4.316.48a1.113 1.113 0 0 0 1.237-1.1l.025-4.342Z"
          fill="#408CF7"
        />
      </g>
      <path
        d="M13.351 17.567c.618 0 1.12.501 1.12 1.12v3.586a1.12 1.12 0 1 1-2.24 0v-3.587c0-.618.502-1.12 1.12-1.12ZM18.015 14.836c.619 0 1.12.502 1.12 1.12v9.048a1.12 1.12 0 0 1-2.24 0v-9.048c0-.618.502-1.12 1.12-1.12ZM22.681 18.477c.618 0 1.12.502 1.12 1.12v2.24a1.12 1.12 0 0 1-2.24 0v-2.24c0-.618.502-1.12 1.12-1.12Z"
        fill="#fff"
      />
      <defs>
        <filter
          id="a"
          x={12.987}
          y={1.973}
          width={27.239}
          height={27.239}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation={1.513} />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1941_172928"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1941_172928"
            result="shape"
          />
        </filter>
        <filter
          id="b"
          x={-1.314}
          y={1.049}
          width={39.044}
          height={39.045}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation={2.157} />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1941_172928"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1941_172928"
            result="shape"
          />
        </filter>
      </defs>
    </StyledIcon>
  );
};

BatchLanguages.propTypes = {
  color: PropTypes.string
};

BatchLanguages.defaultProps = {
  color: 'var(--color-text-primary)'
};

export default BatchLanguages;
